var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlaB154(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.647,
    height: 70.648,
    viewBox: "0 0 70.647 70.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34354",
    "data-name": "Group 34354",
    transform: "translate(-175.1 -860.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32445",
    "data-name": "Group 32445",
    transform: "translate(-342 -245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32444",
    "data-name": "Group 32444",
    transform: "translate(569 1107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32442",
    "data-name": "Group 32442",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32441",
    "data-name": "Group 32441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32440",
    "data-name": "Group 32440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32439",
    "data-name": "Group 32439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26418",
    "data-name": "Path 26418",
    d: "M4682.592,2892.594a11.482,11.482,0,0,1-8.567,3.9v3.109c0,4.731.333,10.89,8.567,14.4h0c8.233-3.51,8.567-9.669,8.567-14.4v-3.109A11.482,11.482,0,0,1,4682.592,2892.594Z",
    transform: "translate(-4674.025 -2892.594)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32443",
    "data-name": "Group 32443",
    transform: "translate(4.735 6.899)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x2: 1.483,
    transform: "translate(6.18 3.832)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26419",
    "data-name": "Path 26419",
    d: "M4706.954,2934.986v3.832h-3.832",
    transform: "translate(-4703.123 -2934.986)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    y1: 1.666,
    transform: "translate(3.832 5.997)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32446",
    "data-name": "Group 32446",
    transform: "translate(5 -97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32433",
    "data-name": "Group 32433",
    transform: "translate(172 959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26415",
    "data-name": "Path 26415",
    d: "M4922.721,2014.009l6.417,6.417a20.591,20.591,0,0,0,29.12,0h0a20.592,20.592,0,0,0,0-29.121l-12.833-12.833-29.121,29.12-12.832-12.833a20.592,20.592,0,0,1,0-29.12h0a20.59,20.59,0,0,1,29.12,0l6.895,6.894",
    transform: "translate(-4897.441 -1959.608)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26416",
    "data-name": "Path 26416",
    d: "M4915.542,1979.952h0a11.535,11.535,0,0,0,0,16.313l4.686,4.686",
    transform: "translate(-4902.834 -1967.062)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26417",
    "data-name": "Path 26417",
    d: "M4980.179,2032.625h0a11.535,11.535,0,0,0,0-16.312l-4.685-4.685",
    transform: "translate(-4926.039 -1978.667)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlaB154);
export default __webpack_public_path__ + "static/media/hla-b-15-4.47190ed06bb5a53c0f920767f181b4a8.svg";
export { ForwardRef as ReactComponent };